import React, { useEffect, useState } from "react";
import { api } from "../../../api";
import { useDispatch } from "react-redux";
import { setSelectedRecommendedAction } from "../../../store/projects/actions";

export const useRecommendationData = (id: string, projectData: any) => {
  const dispatch = useDispatch();
  const [geoJsonObjects, setGeoJsonObjects] = useState<Array<GeoJSON.FeatureCollection<any>>>();
  const [recommendationProjectData, setRecommendationProjectData] = useState({});

  useEffect(() => {
    const fetchAllData = async () => {
      let projectResponseData = projectData;
      if (projectData?.id !== id) {
        dispatch(setSelectedRecommendedAction(undefined));
        const projectResponse = await api.get(`/recommendations/forest/${id}`);
        projectResponseData = projectResponse.data;
        dispatch(setSelectedRecommendedAction(projectResponseData));
      }

      const responseAggregated = await api.get(
        `/v2/aggregate-recommendation-features/forest/?country_code=${projectResponseData?.country_code}&adm_name=${projectResponseData?.adm2}`,
      );
      setGeoJsonObjects(responseAggregated?.data);
    };
    if (id) {
      fetchAllData().catch(console.error);
    }
  }, [id]);

  return {
    geoJsonObjects,
    recommendationProjectData,
  };
};
